import { Button, Typography } from "@mui/material";

export default function ButtonComponent({
  variant,
  fontSize,
  buttonText,
  fullWidth,
  onClick,
  disabled,
  color,
  type,
  sx,
}) {
  return (
    <Button
      type={type}
      sx={{ ...sx, textTransform: "none" }}
      fullWidth={fullWidth}
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      color={color}
    >
      <Typography
        variant="body2"
        sx={{
          fontSize: fontSize,
          fontWeight: 500,
          fontFamily: "Sofia Pro",
        }}
      >
        {buttonText}
      </Typography>
    </Button>
  );
}
